/**
 * BUG-124 — the body of POST /api-keys.
 *
 * Alibaba gives each Qwen workspace its own API address and a key only works
 * there, so the form asks for it. Only providers that take one ever send it:
 * the server refuses an address for any other provider (and for anything that
 * is not an Alibaba Cloud https address).
 */

/** Providers whose key can carry its own API address. Mirrors the server. */
const BASE_URL_PROVIDERS: ReadonlySet<string> = new Set(["qwen"]);

export function providerTakesBaseUrl(provider: string): boolean {
  return BASE_URL_PROVIDERS.has(provider);
}

export interface CreateKeyBody {
  agencyclient_id: number | null;
  provider: string;
  key: string;
  base_url?: string;
}

export function buildCreateKeyBody(input: {
  scope: "workspace" | "tenant";
  agencyclientId: number | null;
  provider: string;
  key: string;
  baseUrl: string;
}): CreateKeyBody {
  const body: CreateKeyBody = {
    agencyclient_id: input.scope === "workspace" ? input.agencyclientId : null,
    provider: input.provider,
    key: input.key.trim(),
  };
  const baseUrl = input.baseUrl.trim();
  if (providerTakesBaseUrl(input.provider) && baseUrl !== "") body.base_url = baseUrl;
  return body;
}
